// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hZaw","question":"styles_question__27dIJ","inputVisibleButton":"styles_inputVisibleButton__2Lexb","note":"styles_note__3RzoL"};